import {Component, Element, Event, type EventEmitter, h, Listen, Prop, State, Watch} from '@stencil/core';
import {getValues} from './exchange-community-actions';
import {translations} from './exchange-community-translations';
import {widgetStatistics} from './exchange-community-statistics';
import type {AnalyticsGenericEvent} from '../../../utils/analytics/AnalyticsGenericEvent';
import { makeLogger } from '../../../logger/logger';
import action_editor from '../../result-page/new-result-cards/public/community-card/action_editor 1.svg';
import { GenericCardThumbnail } from '../../result-page/new-result-cards/generic-subcomponents/generic-card-thumbnail/generic-card-thumbnail';

const { warn } = makeLogger({
  pathToCurrentFile: 'components/widgets/exchange-community/exchange-community.tsx',
  loggersList: ['warn']
});

@Component({
  tag: 'uiaas-search-widget-exchange-community',
  styleUrl: 'exchange-community.scss',
  shadow: true,
  assetsDirs: ['assets-exchange-community']
})
export class WidgetExchangeCommunity {

  @Prop() readonly perPage = 10;
  @Prop({attribute: 'term', mutable: true}) termAttribute: string = ''; //eslint-disable-line @stencil-community/strict-mutable
  @Prop() readonly country: string;
  @Prop() readonly language: string;
  @Prop({mutable: true}) tab: string;//eslint-disable-line @stencil-community/strict-mutable
  @Prop() readonly isDashboardView: boolean = false;
  @Prop() readonly screen: 'desktop' | 'mobile';
  @Prop() readonly analyticsTabName?: string;
  @Prop() readonly strategies: any;//eslint-disable-line @typescript-eslint/no-explicit-any

  //DRUTY!!! Co się tutaj dzieje?!
  @Prop({mutable: true, reflect: true}) threshold = this.isDashboardView ? 4 : 3; //eslint-disable-line

  @Prop({mutable: true})
    labelProvider?: (a, b) => string;

  @Prop() readonly mockedData: Array<any> = [];//eslint-disable-line @typescript-eslint/no-explicit-any

  @Prop() readonly apiEndpoint: string;
  @Prop() readonly apigeeAuth: string;
  @Prop() readonly apigeeTokenUrl: string;

  @State() _answers: Array<any> = [];//eslint-disable-line @typescript-eslint/no-explicit-any

  @Element() el: HTMLElement;

  @State() requestWasSent = {
    mobile: false,
    desktop: false
  };

  @Event({
    eventName: 'search:widgetEvent',
    composed: true,
    cancelable: true,
    bubbles: true,
  })
    statisticsEventEmitter: EventEmitter<AnalyticsGenericEvent>;

	@Event({
	  eventName: 'search:exchangeWidgetVisibilityEvent',
	  composed: true,
	  cancelable: true,
	  bubbles: true,
	})
	  exchangeWidgetVisibilityEmmiter: EventEmitter<{visibility: boolean}>;

	private url = 'https://community.se.com/t5/forums/searchpage/tab/message?advanced=false&allow_punctuation=false&q=';

	private successCallback = async (res) => {

	    const tab = this.analyticsTabName ?? this.tab;
	    this._answers = res.slice(0,2);

	    this.exchangeWidgetVisibilityEmmiter.emit(
	      {
	        visibility: this._answers && this._answers?.length > 0
	      }
	    );

	    if (tab) {
	      this.statisticsEventEmitter.emit(
	        widgetStatistics.sendPresentationStatisticsEvent(
	          tab,
	          this._answers && this._answers?.length > 0
	        )
	      );
	    }
	};

	private getCurrentState = () => {
	    return {
	      term: this.termAttribute,
	      perPage: this.perPage,
	      threshold: this.threshold,
	      mockedData: this.mockedData,
	      apiEndpoint: this.apiEndpoint,
	      apigeeAuth: this.apigeeAuth,
	      apigeeTokenUrl: this.apigeeTokenUrl
	    };
	};

  @Watch('termAttribute')
  @Watch('threshold')
  @Watch('perPage')
	termWatch(newValue, oldValue) {
	    if (oldValue !== newValue) {
	      this._answers = [];
	      const data = this.getCurrentState();
	      return getValues(data, this.successCallback);
	    }
	}

  @State() mobileView: boolean;

  @Listen('resize', {target: 'window'})
  handleResize(e) {
      this.handleCurrentViewMode(e.target.window);
  }

  @Watch('mobileView')
  watchMobile() {
      if (this.screen) {
        return this.sendRequest();
      }
  }

  private sendRequest() {
      const data = this.getCurrentState();

      if (this.screen === 'mobile' && this.mobileView && !this.requestWasSent.mobile) {
        this.requestWasSent.mobile = true;
        return getValues(data, this.successCallback);
      } else if (this.screen === 'desktop' && !this.mobileView && !this.requestWasSent.desktop) {
        this.requestWasSent.desktop = true;
        return getValues(data, this.successCallback);
      }
  }

  private handleCurrentViewMode(e) {
      if (e.innerWidth > 780) {
        this.mobileView = false;
      } else {
        this.mobileView = true;
      }
  }

  private emitSearchStatisticsEvent = (e: AnalyticsGenericEvent) => {
      this.statisticsEventEmitter.emit(
        e
      );
  };

  componentWillLoad() {
      const {communitySupport, communitySupportLabel, seeAll, viewAll} = translations;

      this.handleCurrentViewMode(window);

      if (!this.labelProvider) {
        this.labelProvider = (label, fallback) => {
            const language = this.language?.toLowerCase();
            let translation;

            switch (label) {
            case 'exchange-community.widget.community-support':
              translation = communitySupport[language] || fallback;
              break;
            case 'exchange-community.see-all':
              translation = seeAll[language] || fallback;
              break;
            case 'exchange-community.widget.community-support-label':
              translation = communitySupportLabel[language] || fallback;
              break;
            case 'tab.dashboard.view-all':
              translation = viewAll[language] || fallback;
              break;
            default:
              translation = fallback;
              break;
            }

            if (fallback === translation) {
              warn('Search Rich Widget:FaqComponent -> Missing label for ', label, 'using fallback: ', fallback);
            }

            return translation;
        };
      }

      if (this.screen) {
        return this.sendRequest();
      } else {
        const data = this.getCurrentState();
        return getValues(data, this.successCallback);
      }
  }

  connectedCallback() {
      const closestTabEl = this.el.closest('uiaas-search-tab');
      if (closestTabEl) {
        this.tab = closestTabEl['tabName'];
      }
  }

  render() {
      const tab = this.analyticsTabName ?? this.tab;
      const seeAllUrl = `${this.url}${this.termAttribute?.length && this.termAttribute !== '*' ? this.termAttribute : ''}`;
      return (
        this._answers?.length > 0 &&
        <div class={this.isDashboardView ? 'ec-widget__container-dashboard' : 'ec-widget__container'}>
          <h3 class='ec-widget__title'>{this.labelProvider('exchange-community.widget.community-support', 'Community Support')}</h3>
          <div class='ec-widget__subtitle'>
            <p class={this.isDashboardView ? 'ec-widget__description-dashboard' : 'ec-widget__description'}>{this.labelProvider('exchange-community.widget.community-support-label', 'Get 24/7 support from your peers and experts')}</p>
            <div class="ec-widget__view-all">
              <qds-standalone-link importance="emphasized" class={this.isDashboardView ? 'ec-widget__link-dashboard' : 'ec-widget__link'} target="_blank" referrer-policy="no-referrer"
                href={seeAllUrl}
                onMouseDown={(e) => this.emitSearchStatisticsEvent(widgetStatistics.sendUserRedirectionStatisticsEvent(tab, e.button == 0 ? 'left' : 'right', 'seeAll', null, `${seeAllUrl}`))}
                onKeyDown={e => {
                    if (e.key === 'Enter') {
                      this.emitSearchStatisticsEvent(widgetStatistics.sendUserRedirectionStatisticsEvent(tab, e.key, 'seeAll', null, `${seeAllUrl}`));
                    }
                }}
              >
                <span class="ec-widget__link-text">
                  {this.isDashboardView
                    ? this.labelProvider('tab.dashboard.view-all-results', 'View all Results')
                    : this.labelProvider('exchange-community.see-all', 'See all')}
                </span>
              </qds-standalone-link>
            </div>
          </div>
          <ul class={this.threshold == 4 ? 'ec-widget__list-dashboard' : 'ec-widget__list'}>
            {
              this._answers.map((el, index) => {
                  el = {
                    ...el,
                    ...el.en_WW
                  };
                  el.url = el.openUrl;
                  el.thumbnailUrl = el.en_WW?.image?.href;
                  if (index < this.threshold) {
                    return (
                      <dashboard-community-item
                        rtl={false}
                        labelProvider={(e, f) => this.labelProvider(e, f)}
                        doc={el}
                        index={index}
                        strategies={this.strategies}
                        section={'support/community'}
                        showPlaceholder={undefined}
                        country={this.country}
                        language={this.language}
                      />
                    );
                  }
              })}
          </ul>
        </div>
      );
  }
}
